import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {colorToRgbaArray, rgbaToHexString} from '@Utils/color.util';
import {BaseGlowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';

export function ItemGlowColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemGlowColor = useGetKeyFromShadowOfActiveItem('color');

  if (!activeItem || !activeItemGlowColor) {
    throw new Error(`No active item`);
  }

  const updateGlowColor = (glowColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        shadow: {
          color: rgbaToHexString(glowColor),
        },
      },
      {undoable}
    );
  };

  return <BaseGlowColorPanel glowColor={colorToRgbaArray(activeItemGlowColor)} onUpdateGlow={updateGlowColor} />;
}
